type AxiosShapedError = {
  code?: string;
  response?: { status?: number };
};

export const isAxiosForbidden = (error: unknown): boolean =>
  (error as AxiosShapedError | null)?.response?.status === 403;

/** Gateway/proxy dropped the POST while Lambda may still be in Cognito. */
export const isStaffRegulatorCreateAborted = (error: unknown): boolean => {
  const shaped = error as AxiosShapedError | null;
  if (!shaped || typeof shaped !== "object") {
    return false;
  }
  if (shaped.response?.status === 504) {
    return true;
  }
  return shaped.code === "ECONNABORTED" || shaped.code === "ERR_NETWORK";
};
